import { Link } from "react-router-dom";

const LINKS = [
  { to: "/ethos", label: "Ethos" },
  { to: "/services", label: "Services" },
  { to: "/work", label: "Work" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => (
  <footer className="border-t border-line" data-testid="site-footer">
    <div className="container-ak pb-10 pt-16 md:pb-14 md:pt-24">
      <img
        src="/aklive-logo.png"
        alt=""
        aria-hidden="true"
        width="473"
        height="130"
        loading="lazy"
        className="w-full max-w-[900px] select-none"
      />
      <div className="mt-12 flex flex-col gap-8 md:mt-16 md:flex-row md:items-end md:justify-between">
        <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-${l.label.toLowerCase()}-link`}
              className="link-underline text-sm text-ink2 hover:text-ink"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <Link to="/contact" data-testid="footer-start-project-btn" className="btn-secondary h-11 px-6 text-sm md:self-end">
          Start a Project
        </Link>
      </div>
      <div className="mt-12 flex flex-col gap-2 border-t border-line pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-ink2 sm:flex-row sm:justify-between">
        <span>© 2026 AKLIVE</span>
        <span>Built for what comes next</span>
      </div>
    </div>
  </footer>
);
